module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/amex-payment-card-e48dbb4411de9a312f63c438a1cf418a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/amex-payment-card.svg
// module id = 5IqQ
// module chunks = 24